import React, { useState, useEffect } from "react";

const ticketData = [
  {
    id: 1,
    title: "ADULT REGULAR WEEKEND",
    price: 181300,
    description: [
      "Berlaku untuk pengunjung usia diatas 6 Tahun dengan tinggi badan diatas 120cm",
      "Valid for customer with age above 6 years old with height above 120cm",
      "Tour Aquarium (1× masuk)",
      "Aquarium Tour (1× entry)",
      "Termasuk semua pertunjukan satwa dan Mermaid Show",
      "Includes all animal and Mermaid Show",
    ],
  },
  {
    id: 2,
    title: "ADULT PREMIUM WEEKEND",
    price: 220500,
    description: [
      "Berlaku untuk pengunjung usia diatas 6 Tahun dengan tinggi badan diatas 120cm",
      "Valid for customer with age above 6 years old with height above 120cm",
      "Tour Aquarium (akses keluar masuk area di 4 jam pertama)",
      "Aquarium Tour (Multiple Entry within the first 4 hours)",
      "Penukaran tiket dengan jalur cepat",
      "Fast lane ticket redemption",
      "Akses ke Premium Lounge di Lobby JAQS",
      "Access to Premium Lounge at JAQS Lobby",
      "Termasuk semua pertunjukan satwa dan Mermaid Show",
      "Includes all animal and Mermaid Show",
      "1× Fun Game Activity",
      "1× Fun Game Activity",
      "Kipas dan Voucher Premium Benefit",
      "Customized hand fan and Premium Benefit Vouchers",
    ],
  },
  {
    id: 3,
    title: "CHILD REGULAR WEEKEND",
    price: 147000,
    description: [
      "Berlaku untuk pengunjung  dengan usia 2 sampai 6 tahun, dengan maksimal tinggi badan 120 cm",
      "(Gratis untuk anak di bawah 2 tahun)",
      "Valid for customer 2 – 6 years old, with height maximum 120cm (Free entry for child under 2 years old)",
      "Tour Aquarium (1× masuk)",
      "Aquarium Tour (1× entry)",
      "Termasuk semua pertunjukan satwa dan Mermaid Show",
      "Includes all animal and Mermaid Show",
    ],
  },
  {
    id: 4,
    title: "CHILD PREMIUM WEEKEND",
    price: 171500,
    description: [
      "Berlaku untuk pengunjung  dengan usia 2 sampai 6 tahun, dengan maksimal tinggi badan 120 cm",
      "(Gratis untuk anak di bawah 2 tahun)",
      "Valid for customer 2 – 6 years old, with height maximum 120cm (Free entry for child under 2 years old)",
      "Tour Aquarium (akses keluar masuk area di 4 jam pertama)",
      "Aquarium Tour (Multiple Entry within the first 4 hours)",
      "Penukaran tiket dengan jalur cepat",
      "Fast lane ticket redemption",
      "Akses ke Premium Lounge di Lobby JAQS",
      "Access to Premium Lounge at JAQS Lobby",
      "Termasuk semua pertunjukan satwa dan Mermaid Show",
      "Includes all animal and Mermaid Show",
      "1× Fun Game Activity",
      "1× Fun Game Activity",
      "Kipas dan Voucher Premium Benefit",
      "Customized hand fan and Premium Benefit Vouchers",
    ],
  },
];

export default function TicketOptions({ onSubtotalChange, onTicketSelectionChange, formatPrice }) {
  const [quantities, setQuantities] = useState({});

  const handleChange = (id, delta) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: Math.max(0, (prev[id] || 0) + delta),
    }));
  };

  useEffect(() => {
    const total = ticketData.reduce((sum, ticket) => {
      const qty = quantities[ticket.id] || 0;
      return sum + qty * ticket.price;
    }, 0);
    if (onSubtotalChange) onSubtotalChange(total);

    const selected = ticketData
      .filter((ticket) => (quantities[ticket.id] || 0) > 0)
      .map((ticket) => ({
        title: ticket.title,
        price: ticket.price,
        qty: quantities[ticket.id],
      }));
    if (onTicketSelectionChange) onTicketSelectionChange(selected);
  }, [quantities, onSubtotalChange, onTicketSelectionChange]);

  return (
    <div className="space-y-6 mt-6">
      {ticketData.map((ticket) => (
        <div
          key={ticket.id}
          className="border rounded-xl p-6 bg-white/60 shadow-sm"
        >
          <div className="flex flex-col md:flex-row justify-between items-start md:items-start gap-4 md:gap-6">
            {/* Title & Description */}
            <div className="flex-1 min-w-[200px]">
              <h3 className="font-bold text-lg mb-2">{ticket.title}</h3>
              <ul className="text-sm text-gray-800 space-y-1">
                {ticket.description.map((line, i) => (
                  <li
                    key={i}
                    className={i % 2 !== 0 ? "italic text-gray-600" : ""}
                  >
                    {line}
                  </li>
                ))}
              </ul>
            </div>

            {/* Price */}
            <div className="md:text-right text-left font-bold text-lg text-gray-900 min-w-[100px]">
              IDR {formatPrice(ticket.price)}
            </div>

            {/* Quantity Control */}
            <div className="flex items-center gap-2 justify-start md:justify-end min-w-[100px]">
              <button
                onClick={() => handleChange(ticket.id, -1)}
                className="w-9 h-9 rounded-full bg-orange-200 text-orange-700 text-lg font-bold"
              >
                –
              </button>
              <span className="w-6 text-center">{quantities[ticket.id] || 0}</span>
              <button
                onClick={() => handleChange(ticket.id, 1)}
                className="w-9 h-9 rounded-full bg-orange-500 text-white text-lg font-bold"
              >
                +
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
